import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const carouselControlFn = /* @__PURE__ */ createRecipe('carousel-control', {}, [])

const carouselControlVariantMap = {}

const carouselControlVariantKeys = Object.keys(carouselControlVariantMap)

export const carouselControl = /* @__PURE__ */ Object.assign(memo(carouselControlFn.recipeFn), {
  __recipe__: true,
  __name__: 'carouselControl',
  __getCompoundVariantCss__: carouselControlFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: carouselControlVariantKeys,
  variantMap: carouselControlVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, carouselControlVariantKeys)
  },
  getVariantProps: carouselControlFn.getVariantProps,
})